export default __webpack_public_path__ + "static/quiz-bg-question-9f8e471fed62cadcf0eb2c90540b92e6.jpg";